import React from "react";



export default function Accueil({ onNavigate }) {
  const buttonStyle = {
    width: "280px",
    height: "110px",
    margin: "0 1em",
    background: "hsla(83, 71%, 7%, 1.00)",
  color: "#ffffffff",
    borderRadius: "16px",
  fontWeight: "bold",
  fontSize: "1.4em",
  border: "none",
  cursor: "pointer",
  boxShadow: "0 4px 16px #232b2166",
  transition: "transform 0.18s, box-shadow 0.18s",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "Segoe UI, Arial, sans-serif"
  };
  const buttonHover = {
    transform: "scale(1.06)",
    boxShadow: "0 4px 16px #22310755"
  };
  const [hovered, setHovered] = React.useState("");
  return (
  <div style={{ textAlign: "center", minHeight: "100vh", background: "#192c22ff" }}>
      {/* Bandeau vert sous le titre */}
      <div style={{ background: "linear-gradient(90deg,#7ca982 0%,#a3b18a 100%)", padding: "2.5em 0 1.5em 0", marginBottom: "2em" }}>
        <h1
          style={{
            fontSize: "2.5em",
            fontWeight: "bold",
            color: "#232b21",
            marginBottom: "0.5em",
            fontFamily: "Segoe UI, Arial, sans-serif",
            letterSpacing: "1px"
          }}
        >
          FRQNT Agriculture Durable
        </h1>
      </div>
      <div style={{ marginTop: "2.5em" }}>
  <p style={{ fontSize: "1.15em", color: "#e2e9e0ff", marginBottom: "1.2em" }}>
          Université de Sherbrooke – Projet Matière Organique<br />
          Plateforme d'analyse et de gestion des données agricoles et des types de sol
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: "2em", marginTop: "2em" }}>
          <button
            style={{ ...buttonStyle, ...(hovered === "dashboard" ? buttonHover : {}) }}
            onMouseEnter={() => setHovered("dashboard")}
            onMouseLeave={() => setHovered("")}
            onClick={() => onNavigate("dashboard")}
          >Accéder aux données</button>
          <button
            style={{ ...buttonStyle, background: "#7a7c76", ...(hovered === "historique" ? buttonHover : {}) }}
            onMouseEnter={() => setHovered("historique")}
            onMouseLeave={() => setHovered("")}
            onClick={() => onNavigate("historique")}
          >Historique</button>
          <button
            style={{
              ...buttonStyle,
              background: hovered === "pratiques" ? "#7ca982" : "#b7cbb2",
              color: "#fff",
              ...(hovered === "pratiques" ? buttonHover : {})
            }}
            onMouseEnter={() => setHovered("pratiques")}
            onMouseLeave={() => setHovered("")}
            onClick={() => onNavigate("pratiques")}
          >Pratiques</button>
          <button
            style={{
              ...buttonStyle,
              background: hovered === "scenarios" ? "#ffb066" : "#e67c30",
              color: "#fff",
              ...(hovered === "scenarios" ? buttonHover : {})
            }}
            onMouseEnter={() => setHovered("scenarios")}
            onMouseLeave={() => setHovered("")}
            onClick={() => onNavigate("scenarios")}
          >Scénarios</button>
        </div>

        {/* Bulles d'infos projet */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "0.6em",
          margin: "1.5em 0 1.5em 0",
          maxWidth: "700px",
          marginLeft: "auto",
          marginRight: "auto"
        }}>
          <div style={{
            background: "linear-gradient(135deg,rgba(34,197,94,0.20),rgba(16,185,129,0.20))",
            backdropFilter: "blur(8px)",
            borderRadius: "0.6em",
            padding: "0.4em 0.3em",
            textAlign: "center",
            border: "1.5px solid rgba(34,197,94,0.3)"
          }}>
            <p style={{ fontSize: "0.9em", fontWeight: "900", color: "#fff", marginBottom: "0.15em" }}>12,847</p>
            <p style={{ fontSize: "0.6em", fontWeight: "600", color: "#fff" }}>Parcelles BDPPAD</p>
            <p style={{ fontSize: "0.5em", color: "#fff" }}>Données officielles</p>
          </div>
          <div style={{
            background: "linear-gradient(135deg,rgba(59,130,246,0.20),rgba(6,182,212,0.20))",
            backdropFilter: "blur(8px)",
            borderRadius: "0.6em",
            padding: "0.4em 0.3em",
            textAlign: "center",
            border: "1.5px solid rgba(59,130,246,0.3)"
          }}>
            <p style={{ fontSize: "0.9em", fontWeight: "900", color: "#fff", marginBottom: "0.15em" }}>185k</p>
            <p style={{ fontSize: "0.6em", fontWeight: "600", color: "#fff" }}>Hectares analysés</p>
            <p style={{ fontSize: "0.5em", color: "#fff" }}>Région Montérégie</p>
          </div>
          <div style={{
            background: "linear-gradient(135deg,rgba(168,85,247,0.20),rgba(236,72,153,0.20))",
            backdropFilter: "blur(8px)",
            borderRadius: "0.6em",
            padding: "0.4em 0.3em",
            textAlign: "center",
            border: "1.5px solid rgba(168,85,247,0.3)"
          }}>
            <p style={{ fontSize: "0.9em", fontWeight: "900", color: "#fff", marginBottom: "0.15em" }}>999</p>
            <p style={{ fontSize: "0.6em", fontWeight: "600", color: "#fff" }}>Données météo</p>
            <p style={{ fontSize: "0.5em", color: "#fff" }}>5 stations 2024</p>
          </div>
          <div style={{
            background: "linear-gradient(135deg,rgba(251,191,36,0.20),rgba(249,115,22,0.20))",
            backdropFilter: "blur(8px)",
            borderRadius: "0.6em",
            padding: "0.4em 0.3em",
            textAlign: "center",
            border: "1.5px solid rgba(251,191,36,0.3)"
          }}>
            <p style={{ fontSize: "0.9em", fontWeight: "900", color: "#fff", marginBottom: "0.15em" }}>2024</p>
            <p style={{ fontSize: "0.6em", fontWeight: "600", color: "#fff" }}>Données récentes</p>
            <p style={{ fontSize: "0.5em", color: "#fff" }}>Recherche active</p>
          </div>
        </div>
          {/* Trois petites bulles horizontales */}
          <div style={{
            display: "flex",
            justifyContent: "center",
            gap: "0.8em",
            margin: "0 0 1.5em 0"
          }}>
            <div style={{
              background: "#166534",
              color: "#fff",
              borderRadius: "0.7em",
              padding: "0.5em 1em",
              minWidth: "120px",
              textAlign: "center",
              fontWeight: "600",
              fontSize: "0.85em",
              boxShadow: "0 2px 6px rgba(0,0,0,0.06)"
            }}>
              Explorer les Données
            </div>
            <div style={{
              background: "#2563eb",
              color: "#fff",
              borderRadius: "0.7em",
              padding: "0.5em 1em",
              minWidth: "120px",
              textAlign: "center",
              fontWeight: "600",
              fontSize: "0.85em",
              boxShadow: "0 2px 6px rgba(0,0,0,0.06)"
            }}>
              Analyse des Sols
            </div>
            <div style={{
              background: "#7c3aed",
              color: "#fff",
              borderRadius: "0.7em",
              padding: "0.5em 1em",
              minWidth: "120px",
              textAlign: "center",
              fontWeight: "600",
              fontSize: "0.85em",
              boxShadow: "0 2px 6px rgba(0,0,0,0.06)"
            }}>
              Données Météo
            </div>
          </div>

          {/* Titre et sous-titre Objectifs de Recherche */}
          <div style={{
            textAlign: "center",
            margin: "2em 0 0.5em 0"
          }}>
            <h2 style={{
              color: "#fff",
              fontWeight: "900",
              fontSize: "2em",
              marginBottom: "0.5em",
              letterSpacing: "0.02em"
            }}>
              Objectifs de Recherche
            </h2>
            <p style={{
              color: "#fff",
              fontSize: "1.1em",
              fontWeight: "400",
              maxWidth: "700px",
              margin: "0 auto",
              lineHeight: "1.5"
            }}>
              Projet de recherche en géomatique appliquée à l'agriculture durable financé par le FRQNT. Développement d'outils d'aide à la décision pour l'optimisation des pratiques agricoles.
            </p>
          </div>

          {/* Trois paragraphes horizontaux avec icône */}
          <div style={{
            display: "flex",
            justifyContent: "center",
            gap: "0.6em",
            margin: "1.5em 0 1.5em 0",
            maxWidth: "520px",
            marginLeft: "auto",
            marginRight: "auto"
          }}>
            {/* Analyse Géospatiale */}
            <div style={{
              background: "rgba(22,101,52,0.15)",
              borderRadius: "0.6em",
              padding: "0.4em 0.3em 0.3em 0.3em",
              minWidth: "120px",
              textAlign: "center",
              color: "#fff",
              boxShadow: "0 2px 6px rgba(0,0,0,0.04)"
            }}>
              <div style={{
                fontSize: "1.1em",
                marginBottom: "0.15em"
              }}>
                <span role="img" aria-label="SIG">🗺️</span>
              </div>
              <div style={{ fontWeight: "700", fontSize: "0.65em", marginBottom: "0.1em" }}>Analyse Géospatiale</div>
              <div style={{ fontWeight: "500", fontSize: "0.55em", marginBottom: "0.1em", opacity: 0.85 }}>SIG</div>
              <div style={{ fontSize: "0.5em", fontWeight: "400", opacity: 0.85 }}>
                Cartographie et modélisation spatiale des données agricoles
              </div>
            </div>
            {/* Collaboration */}
            <div style={{
              background: "rgba(37,99,235,0.15)",
              borderRadius: "0.6em",
              padding: "0.4em 0.3em 0.3em 0.3em",
              minWidth: "120px",
              textAlign: "center",
              color: "#fff",
              boxShadow: "0 2px 6px rgba(0,0,0,0.04)"
            }}>
              <div style={{
                fontSize: "1.1em",
                marginBottom: "0.15em"
              }}>
                <span role="img" aria-label="Collaboration">🤝</span>
              </div>
              <div style={{ fontWeight: "700", fontSize: "0.65em", marginBottom: "0.1em" }}>Collaboration</div>
              <div style={{ fontWeight: "500", fontSize: "0.55em", marginBottom: "0.1em", opacity: 0.85 }}>Multi</div>
              <div style={{ fontSize: "0.5em", fontWeight: "400", opacity: 0.85 }}>
                Partenariat université-industrie-gouvernement
              </div>
            </div>
            {/* Durabilité */}
            <div style={{
              background: "rgba(124,58,237,0.15)",
              borderRadius: "0.6em",
              padding: "0.4em 0.3em 0.3em 0.3em",
              minWidth: "120px",
              textAlign: "center",
              color: "#fff",
              boxShadow: "0 2px 6px rgba(0,0,0,0.04)"
            }}>
              <div style={{
                fontSize: "1.1em",
                marginBottom: "0.15em"
              }}>
                <span role="img" aria-label="Durabilité">🌱</span>
              </div>
              <div style={{ fontWeight: "700", fontSize: "0.65em", marginBottom: "0.1em" }}>Durabilité</div>
              <div style={{ fontWeight: "500", fontSize: "0.55em", marginBottom: "0.1em", opacity: 0.85 }}>Eco</div>
              <div style={{ fontSize: "0.5em", fontWeight: "400", opacity: 0.85 }}>
                Pratiques agricoles respectueuses de l'environnement
              </div>
            </div>
          </div>

          {/* Bouton bulle Découvrir les Pratiques Durables */}
          {/* Un seul bouton, doublon supprimé */}

          {/* Bouton bulle Découvrir les Pratiques Durables */}
          <div style={{
            display: "flex",
            justifyContent: "center",
            margin: "2em 0 3em 0"
          }}>
            <button
              onClick={() => {
                if (onNavigate) {
                  onNavigate("Pratiques");
                  setTimeout(() => {
                    const el = document.getElementById("catalogue-pratiques");
                    if (el) el.scrollIntoView({ behavior: "smooth" });
                  }, 300);
                }
              }}
              style={{
                background: "linear-gradient(135deg,#22c55e 60%,#166534 100%)",
                color: "#fff",
                border: "none",
                borderRadius: "2em",
                padding: "1.1em 2.5em",
                fontWeight: "800",
                fontSize: "1.25em",
                boxShadow: "0 4px 16px rgba(34,197,94,0.15)",
                cursor: "pointer",
                transition: "transform 0.15s, box-shadow 0.15s",
                outline: "none"
              }}
              onMouseOver={e => {
                e.currentTarget.style.transform = "scale(1.06)";
                e.currentTarget.style.boxShadow = "0 6px 24px rgba(34,197,94,0.22)";
              }}
              onMouseOut={e => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 4px 16px rgba(34,197,94,0.15)";
              }}
            >
              <span style={{ fontSize: "1.5em", marginRight: "0.5em", verticalAlign: "middle" }} role="img" aria-label="Durable">�</span>
              Découvrir les Pratiques Durables
            </button>
          </div>
        </div>
      </div>
  );
}
